/**
 * Datum/Zeit-Formatierung — immer in Event-TZ mit explizitem Label, nie in
 * Browser-TZ. Siehe docs/i18n.md §4.
 */

export function formatEventDate(
  iso: string,
  timezone: string | undefined,
  locale: string,
): string {
  try {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone ?? undefined,
      dateStyle: "full",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

/**
 * Relative Zeitangabe wie „in 4 Tagen", „heute", „vor 2 Tagen". Nutzt die
 * `Intl.RelativeTimeFormat`-API; Ergebnis ist immer in Locale-Sprache.
 */
export function formatRelative(iso: string, locale: string): string {
  const target = new Date(iso).getTime();
  const now = Date.now();
  const diffMs = target - now;
  const absMs = Math.abs(diffMs);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;

  if (absMs < hour) return rtf.format(Math.round(diffMs / minute), "minute");
  if (absMs < day) return rtf.format(Math.round(diffMs / hour), "hour");
  if (absMs < week) return rtf.format(Math.round(diffMs / day), "day");
  if (absMs < month) return rtf.format(Math.round(diffMs / week), "week");
  return rtf.format(Math.round(diffMs / month), "month");
}

export function isPast(iso: string): boolean {
  return new Date(iso).getTime() < Date.now();
}
